/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  NewsListResponse,
  NewsDetailResponse,
  NewsCategoryListResponse,
  NewsTagListResponse,
  CareerListResponse,
  CareerApplyPayload,
  CareerItem
} from '@/types/response-api'
import { AxiosResponse } from 'axios'
import { toast } from 'sonner'
import API, { API_BLOG, APIPARTNER } from './axios.config'

// MARK: NEWS (new API: /news/category, /news/tag, /news/slug, /news/slug/:slug)
export type NewsListParams = {
  page?: number
  limit?: number
  search?: string
  isActive?: boolean
  categorySlug?: string
  tagSlug?: string
}

export const NewsService = {
  fetchCategories: async (): Promise<AxiosResponse<NewsCategoryListResponse>> => {
    return await API_BLOG.get<NewsCategoryListResponse>('/news/category')
  },
  fetchTags: async (): Promise<AxiosResponse<NewsTagListResponse>> => {
    return await API_BLOG.get<NewsTagListResponse>('/news/tag')
  },
  fetchNews: async (params?: NewsListParams): Promise<AxiosResponse<NewsListResponse>> => {
    return await API_BLOG.get<NewsListResponse>('/news/slug', { params: params || {} })
  },
  fetchNewsBySlug: async (slug: string): Promise<AxiosResponse<NewsDetailResponse>> => {
    return await API_BLOG.get<NewsDetailResponse>(`/news/slug/${encodeURIComponent(slug)}`)
  },
  fetchNewsById: async (id: number): Promise<AxiosResponse<NewsDetailResponse>> => {
    return await API_BLOG.get<NewsDetailResponse>(`/news/${id}`)
  }
}
// import { setToken } from './auth'
// MARK:AUTH
// export const AuthService = {
//   createLogin: async (data: {
//     usernameOrEmail: string
//     password: string
//   }): Promise<RootLogin | null> => {
//     try {
//       const res: RootLogin = await API.post('/api/v1/user/authentication/login01', data)

//       if (!res.error) {
//         // Lưu token + user
//         setToken(res.data.accessToken)
//         // setUser(res.data.user)

//         toast.success('Login Successfully!')
//         return res
//       } else {
//         toast.error(res.message)
//         return null
//       }
//     } catch (error: any) {
//       const message = error.response?.data?.message || error.message
//       toast.error(message)
//       return null
//     }
//   },

//   createRegister: async (data: {
//     username: string
//     password: string
//     cpassword: string
//     email: string
//   }): Promise<AxiosResponse | null> => {
//     try {
//       const res: any = await API.post('/api/v1/user/authentication/register', data)
//       if (!res.error) {
//         toast.success('Successful registration!')
//         return res.data
//       } else {
//         toast.error(res.data.message)
//         return null
//       }
//     } catch (error: any) {
//       const message = error.response.data?.message || error.message
//       toast.error(message)
//       return error.response
//     }
//   }
// }

// export const InfoService = {
//   updateInfo: async (data: {
//     fullname: string
//     phone: string
//     email: string
//     birthdate: string
//     current_address: string
//     preferred_workplace: string
//     level: string
//     school: string
//     major: string
//     work_experience: string
//   }): Promise<AxiosResponse | null> => {
//     try {
//       const res: any = await API.put('/api/v1/user/info/update-info', data)
//       if (!res.error) {
//         toast.success('Update information successfully!')
//         return res.data
//       } else {
//         toast.error(res.data.message)
//         return null
//       }
//     } catch (error: any) {
//       const message = error.response.data?.message || error.message
//       toast.error(message)
//       return error.response
//     }
//   },
//   fetchInfo: async (): Promise<AxiosResponse> => {
//     return await API.get('/api/v1/user/info/get-info')
//   },
//   fetchApply: async (id: string): Promise<AxiosResponse> => {
//     return await API.get(`api/v1/user/info/apply/${id}`)
//   }
// }

// MARK: APPLY JOB
type ApplyPostPayload = {
  fullname: string
  phone: string
  email: string
  birthdate: string
  current_address: string
  level: string
  school: string
  major: string
  work_experience: string
}
export const ApplyService = {
  applyPost: async (id: number, data: ApplyPostPayload): Promise<AxiosResponse | null> => {
    try {
      const res: any = await API.put(`/api/v1/user/recruitment/apply/${id}`, data)
      if (!res.error) {
        toast.success(res?.message)
        return res.data
      } else {
        toast.error(res.data?.message || 'Apply failed!')
        return null
      }
    } catch (error: any) {
      const message = error.response?.data?.message || error.message
      toast.error(message)
      return null
    }
  }
}

//MARK: RECRUITMENT (legacy)
export const RecruitmentService = {
  fetchRecruitmentPost: async (): Promise<AxiosResponse> => {
    return await API_BLOG.get('/api/v1/user/recruitment/list-recruitment-user')
  },
  fetchDetailRecruitmentPost: async (slug: string, id: string): Promise<AxiosResponse> => {
    return await API_BLOG.get(`/api/v1/user/recruitment/detail-recruitment-user/${slug}/${id}`)
  }
}

// MARK: CAREER (GET /career?limit&page, GET /career/:slug, POST /career/apply)
export type CareerListParams = {
  page?: number
  limit?: number
  filter?: string
  isActive?: boolean
}

export const CareerService = {
  fetchCareerList: async (
    params?: CareerListParams
  ): Promise<AxiosResponse<CareerListResponse>> => {
    return await API_BLOG.get<CareerListResponse>('/career', { params: params || {} })
  },
  fetchCareerBySlug: async (slug: string): Promise<CareerItem | null> => {
    if (!slug?.trim()) return null
    try {
      const res = await API_BLOG.get<CareerListResponse>(
        `/career/${encodeURIComponent(slug.trim())}`
      )
      const data = res.data?.data as { rows?: CareerItem[] } | CareerItem | undefined
      if (Array.isArray((data as { rows?: CareerItem[] })?.rows)) {
        const rows = (data as { rows: CareerItem[] }).rows
        return rows.length > 0 ? rows[0] : null
      }
      if (data && typeof data === 'object' && 'id' in data) {
        return data as CareerItem
      }
      return null
    } catch {
      return null
    }
  },
  applyForCareer: async (payload: CareerApplyPayload): Promise<AxiosResponse | null> => {
    try {
      const res: any = await API_BLOG.post('/career/apply', payload)
      if (res?.data?.status !== false) {
        toast.success(res?.data?.message ?? 'Application submitted successfully!')
        return res
      }
      toast.error(res?.data?.message ?? 'Apply failed!')
      return null
    } catch (error: any) {
      const message = error.response?.data?.message || error.message
      toast.error(message)
      return null
    }
  }
}

//MARK: BLOG (contact, partner fields – news now uses NewsService)
export const BlogService = {
  fetchListFields: async (): Promise<AxiosResponse> => {
    return await APIPARTNER.get('/api/v1/common/partner/field')
  },

  //MARK: CONTACT - Create a new contact (POST /contact)
  createContact: async (data: {
    name: string
    phone: string
    email: string
    job: string
    company: string
    content: string
  }): Promise<unknown> => {
    try {
      const res = await API.post('/contact', data)
      toast.success('Contact created successfully!')
      return res
    } catch (error: any) {
      const message = error.response?.data?.message || error.message
      toast.error(message)
      throw error
    }
  },

  createCollaboration: async (data: {
    firstname: string
    lastname: string
    email: string
    phone: string
    position: string
    company: string
    industry: string
    location: string
    size: string
    field: string
    content: string
  }): Promise<unknown> => {
    try {
      const res = await API.post('/collaboration', data)
      toast.success('Contact created successfully!')
      return res
    } catch (error: any) {
      const message = error.response?.data?.message || error.message
      toast.error(message)
      throw error
    }
  }
}
